import { jsx as _jsx } from "react/jsx-runtime";
/**
 * <ThemeToggle /> — cycles light → dark → system → light.
 *
 * Per CHARTE-GRAPHIQUE-CLARI.md §3.3:
 *  - 36×36 button, radius-md, transparent at rest, bg-subtle on hover
 *  - Lucide icons (Sun / Moon / Monitor) at 20px, stroke 1.5
 *  - Dynamic aria-label describing the next state (not the current one)
 *  - Focus visible with --color-border-focus ring
 *
 * `aria-label` strings are supplied by the host app via `labels` so that
 * @clari/ui stays free of any i18next dependency. English fallbacks are
 * provided for the rare case of a missing translation.
 */
import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from '../hooks/useTheme.js';
import { cn } from '../utils/cn.js';
const NEXT_THEME = {
    light: 'dark',
    dark: 'system',
    system: 'light',
};
const FALLBACK_LABELS = {
    switchToLight: 'Switch to light mode',
    switchToDark: 'Switch to dark mode',
    switchToSystem: 'Switch to system theme',
};
export function ThemeToggle({ defaultMode, labels, className, }) {
    const themeOpts = defaultMode ? { defaultMode } : undefined;
    const { theme, setTheme } = useTheme(themeOpts);
    const L = labels ?? FALLBACK_LABELS;
    const next = NEXT_THEME[theme];
    const ariaLabel = next === 'light'
        ? L.switchToLight
        : next === 'dark'
            ? L.switchToDark
            : L.switchToSystem;
    const Icon = theme === 'light' ? Sun : theme === 'dark' ? Moon : Monitor;
    return (_jsx("button", { type: "button", onClick: () => {
            setTheme(next);
        }, "aria-label": ariaLabel, className: cn('clari-theme-toggle', className), "data-theme-mode": theme, children: _jsx(Icon, { size: 20, strokeWidth: 1.5, "aria-hidden": "true", focusable: "false" }) }));
}
//# sourceMappingURL=ThemeToggle.js.map